module.exports = __webpack_public_path__ + "static/rose_quartz-56520bb5cf65fbecfaa2523faf6997f2.svg";